export const CONSTS = {
  LOCATION_CODE: $localize`Location Code`,
  LOCATION_NAME: $localize`Location Name`,
  PORT_CODE: $localize`Port Code`,
  PKG_SLIC: $localize`PKG SLIC`,
  BILLING_PORT_CODE: $localize`Billing Port Code`,
  REGION: $localize`Region`,
  DISTRICT: $localize`District`,
  OPSYS_ID: $localize`OPSYS ID`,
  CIS_DEST: $localize`CIS Dest`,
  COUNTRY: $localize`Country`,
  PRIMARY_EMAIL: $localize`Primary Email`,
  SECOND_EMAIL: $localize`Secondary Email`,
  TIMEZONE: $localize`Time Zone`,
};

export const COUNTRY_LIST = [
  {
    label: $localize`US`,
    value: $localize`US`,
    currency: $localize`USD`,
  },
  {
    label: $localize`UK`,
    value: $localize`UK`,
    currency: $localize`GBP`,
  },
  {
    label: $localize`CA`,
    value: $localize`CA`,
    currency: $localize`CAD`,
  },
  {
    label: $localize`IN`,
    value: $localize`IN`,
    currency: $localize`INR`,
  },
  {
    label: $localize`JP`,
    value: $localize`JP`,
    currency: $localize`JPY`,
  },
];
